
// Navigation detection service for determining KPI creation behavior
let lastVisitedTab: string | null = null;
let navigationSourceForKpiCreation: 'customer-kpis' | 'other' | null = null;

export const recordTabVisit = (tabName: string) => {
  console.log(`Recording tab visit: ${tabName}`);
  lastVisitedTab = tabName;
};

export const setNavigationSourceForBusinessValue = () => {
  console.log(`Setting navigation source. Last visited tab: ${lastVisitedTab}`);
  navigationSourceForKpiCreation = lastVisitedTab === 'customer-kpis' ? 'customer-kpis' : 'other';
  console.log(`Navigation source set to: ${navigationSourceForKpiCreation}`);
};

export const getNavigationSourceForKpiCreation = (): 'customer-kpis' | 'other' | null => {
  return navigationSourceForKpiCreation;
};

export const resetNavigationSource = () => {
  navigationSourceForKpiCreation = null;
  console.log('Navigation source reset');
};
